<script setup lang="ts">
import type { HubStatus } from '@/modules/Workspaces/KnowledgeHub/Hubs/types'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import type { IconName } from '@/uiKit/IconName'
import IconSprite from '@/uiKit/IconSprite.vue'
import { computed } from 'vue'

const props = defineProps<{ status: HubStatus }>()

const states: Record<HubStatus, { text: string; icon: IconName; iconClass?: string }> = {
  ready: {
    text: 'Ready',
    icon: 'check-circle-fill',
    iconClass: 'text-text-success',
  },
  processing: {
    text: 'Processing',
    iconClass: 'text-text-interactive',
    icon: 'switch',
  },
  error: {
    text: 'Error',
    icon: 'warning',
    iconClass: 'text-text-warning',
  },
  stale: {
    text: 'Re-index',
    icon: 'switch',
    iconClass: 'text-text-error',
  },
}

const isNonActionable = computed(() => props.status !== 'stale')
</script>

<template>
  <DarwinButton
    size="md"
    rounded
    :inert="isNonActionable"
    variant="neutral"
    :class="{
      'bg-background-transparent': isNonActionable,
    }"
  >
    <template #leading-icon>
      <IconSprite
        v-if="states[status].icon"
        :class="states[status].iconClass"
        :icon="states[status].icon"
        size="sm"
      />
    </template>
    <template #default>
      {{ states[status].text }}
    </template>
  </DarwinButton>
</template>
